<template>
  <!-- zz:管理员创建订单 -->
  <div class="page-container main">
    <el-form size="small" class="form" label-width="120px" :rules="rules" :model="form" ref="form">
      <!--搜索医院名称-->
      <el-form-item label="医院" class="top-form-item">
        <el-autocomplete
          class="inline-input"
          v-model="activeHospitalName"
          :fetch-suggestions="onHospitalQuerySearch"
          placeholder="搜索医院名称"
          :trigger-on-focus="false"
          @select="onSelectHospital"
        />
      </el-form-item>
      <!--级联菜单选择 医院-科室-医生 (一个科室可能有多个医生)-->
      <el-form-item label="医生" class="top-form-item" prop="doctorInfo" v-if="activeHospitalObj">
        <el-cascader v-model="form.doctorInfo" :props="props" :style="{width: '216px'}"></el-cascader>
      </el-form-item>
      <!--级联菜单选择 其他表单(患者姓名/患者ID/患者电话/病情简述及重建重点)-->
      <el-form-item v-for="item in formList" :label="item.label" :key="item.prop" :prop="item.prop" :class="item.type" v-if="activeHospitalObj">
        <template v-if="item.prop === 'doctorName'">
          <el-input :type="item.type || 'text'" v-model="form[item.prop]"></el-input>
        </template>
        <el-input v-else :type="item.type || 'text'" v-model="form[item.prop]"></el-input>
      </el-form-item>
      <!-- 选择重建类型 -->
      <el-form-item label="重建类型" v-model="reconData" required="required" v-if="activeHospitalObj">
        <div class="mockData">
          <el-table :data="reconData" ref="mockTable" border :show-header="false" style="width: 80%">
            <el-table-column label="一级" width="150">
              <template slot-scope="scope">
                <el-checkbox
                  v-model="scope.row.check"
                  @change="changeCheck(scope.row.id,scope.row.level)"
                >{{scope.row.name+'(默认)'}}
                </el-checkbox>
              </template>
            </el-table-column>
            <el-table-column label="二级">
              <template slot-scope="scope">
                <el-checkbox
                  v-for="item in scope.row.children"
                  :key="item.id"
                  v-model="item.check"
                  v-if="!item.ext"
                  @change="changeCheck(scope.row.id,item.level)"
                >{{item.name}}
                </el-checkbox>
                <div style="border-bottom: 1px dashed #ccc"></div>
                <label class="addition">附加项目：</label>
                <el-checkbox
                  v-for="item in scope.row.children"
                  :key="item.id"
                  v-model="item.check"
                  v-if="item.ext"
                  @change="changeCheck(scope.row.id,item.level)"
                >{{item.name}}
                </el-checkbox>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </el-form-item >
      <!-- 上传文件 -->
      <el-form-item label="文件">
        <FileUploader
          ref="rawUpload"
          title="原始文件"
          pathName="raw"
          @success="onRawFileSuccess"
          @deleted="onRawDelected"
          required="required"
        ></FileUploader>
        <FileUploader
          ref="examUpload"
          :title="examTitle"
          pathName="exam_report"
          @success="onExamFileSuccess"
          @deleted="onExamReportDelected"
          :limit="5"
        ></FileUploader>
      </el-form-item>
      <!-- 提交 -->
      <el-form-item>
<!--        <el-button type="primary" @click="onSave" v-if="pageType === 'create'">保存</el-button>-->
        <el-button type="primary" @click="onSubmit" :disabled="!form.doctorInfo[2]">提交</el-button>
        <el-button>取消</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>
<script>
import {
  mapState
} from 'vuex';
import * as R from 'ramda';
import tip from '@/utils/tip';
import {isAdmin, isDoc, isAgent} from '@/utils';
import {task as taskApi} from '@/api';
import FileUploader from '@/comp/FileUploader';

const formList = [
  {label: '患者姓名', prop: 'patientName', required: true},
  {label: '患者ID', prop: 'examPatientId', required: false},
  {label: '患者电话', prop: 'patientPhone'},
  {label: '病情简述及重建重点', type: 'textarea', prop: 'note', required: true},
];

const form = {
  doctorName: '',
  patientName: '',
  examPatientId: '',
  patientPhone: '',
  note: '',
  rawFile: '',
  examReportFile: [],
  doctorInfo: []
};

export default {
  name: 'AgentOrderCreate',
  data() {
    let that = this;
    return {
      addForm: {
        mobile: '',
        name: ''
      },
      pageType: 'create',
      form: R.clone(form),
      reconData: [],
      props: {
        lazy: true,
        lazyLoad(node, resolve) {
          const {level} = node;
          level === 0 && that.activeHospitalObj && taskApi.hospitalListName({name: that.activeHospitalObj.name}).then(res => {
            const nodes = res.data.data.map(item => ({
              value: item.id,
              label: item.name,
              localId: item.localId,
              leaf: false
            }));
            resolve(nodes);
          });
          level === 1 && taskApi.departmentHospitalList({localId: node.data.localId}).then(res => {
            const nodes = res.data.sub.map(item => ({
              value: item.id,
              label: item.name,
              localId: item.localId,
              leaf: false
            }));
            resolve(nodes);
          });
          level === 2 && taskApi.doctorDepartmentList({local_id: node.data.localId}).then(res => {
            const nodes = res.data.map(item => ({
              value: {
                doctorId: item.id,
                departmentId: item.departmentId,
                doctorName: item.name,
                doctorPhone: item.mobile
              },
              label: `${item.name}(${item.mobile})`,
              localId: item.localId,
              leaf: true
            }));
            resolve(nodes);
          });
        }
      },
      activeHospitalName: '',
      activeHospitalObj: null
    };
  },
  components: {
    FileUploader,
  },
  computed: {
    ...mapState('common', ['userInfo']),
    formList() {
      return formList;
    },
    rules() {
      const ru = {};
      R.pipe(
        R.filter(R.propEq('required', true)),
        R.forEach(({label, prop}) => {
          ru[prop] = [
            {required: true, message: `请输入${label}`, trigger: 'blur'},
          ];
        }),
      )(formList);
      ru['doctorInfo'] = [{required: true, message: '请选择医生', trigger: 'blur'}];
      return ru;
    },
    isAdmin() {
      const {role} = this.userInfo;
      return isAdmin(role);
    },
    isDoc() {
      const {role} = this.userInfo;
      return isDoc(role);
    },
    isAgent() {
      const {role} = this.userInfo;
      return isAgent(role);
    },
    examTitle() {
      if (this.isDoc) {
        return '诊断报告及其他';
      }
      return '诊断报告';
    },
  },
  async mounted() {
    this.onCreated();
    this.loadReconData();
    this.findTodoTask();
  },
  watch: {
    '$route'() {
      this.onCreated();
    },
  },
  methods: {
    async onCreated() {
      this.resetForm();
      const {id} = this.$route.params;
      if (id) {
        this.pageType = 'unsubmit';
        const data = await taskApi.fetchById(id);
        if (data.code === 10000) {
          this.form = R.pick(R.keys(form), data.data);
          this.$refs.rawUpload.setFile({paths: [this.form.rawFile]});
          this.$refs.examUpload.setFile({paths: this.form.examReportFile});
        }
      }
    },
    resetForm() {
      this.pageType = 'create';
      this.form = R.clone(form);
      this.$refs.rawUpload.reset();
      this.$refs.examUpload.reset();
    },
    checkvalid() {
      return new Promise(resolve => {
        this.$refs.form.validate(async(valid) => {
          if (!this.form.rawFile) {
            tip.warning('请上传原始文件');
            return resolve(false);
          }
          if (valid) {
            return resolve(true);
          }
        });
      });
    },
    onRawFileSuccess({paths}) {
      this.form.rawFile = R.head(paths);
    },
    onExamFileSuccess({paths}) {
      this.form.examReportFile = paths;
    },
    toOrderAll() {
      if (this.isDoc || this.isAgent) {
        this.$router.push({
          name: 'OrderAll',
        });
      } else {
        this.$router.push({
          name: 'OrderAllInner',
        });
      }
    },
    async onSave() {
      const valid = await this.checkvalid();
      if (!valid) return;
      const data = await taskApi.create({
        ...this.form.doctorInfo[2],
        examPatientId: this.form.examPatientId,
        examReportFile: this.form.examReportFile,
        note: this.form.note,
        patientName: this.form.patientName,
        patientPhone: this.form.patientPhone,
        rawFile: this.form.rawFile
      }) || {};
      if (data.code === 10000) {
        tip.success('订单已保存到<待提交>，请尽快提交');
        this.resetForm();
        this.toOrderAll();
      }
    },
    async onSubmit() {
      const valid = await this.checkvalid();
      if (!valid) return;
      let id = this.$route.params.id;

      let selectedRecon = '';
      this.reconData.forEach(item => {
        // 先处理一级
        if (item.check) {
          selectedRecon += item.id + ',';
        }
        // 再处理二级
        item.children.forEach(child => {
          if (child.check) {
            selectedRecon += child.id + ',';
          }
        });
      });
      if (selectedRecon.length <= 0) {
        tip.error('请选择重建类型！');
        return;
      }

      if (!this.form.examReportFile || this.form.examReportFile.length <= 0) {
        let warning = '诊断报告暂未上传，继续操作可能导致系统输出三维器官模型同临床开具的影像诊断报告存在不一致的情形——尤其是对病灶的数量、位置、大小等。请确认是否在未提交影像报告的情况下开始重建。如点击确认，则表明您接受精诊科技提供的此次三维重建服务仅需以此患者合格、清晰的医学影像所见信息为准。';
        this.$confirm(warning, '风险警告', {
          confirmButtonText: '确定提交',
          cancelButtonText: '取消',
          type: 'warning',
        }).then(async() => {
          await this.doSubmit(id, selectedRecon);
        });
      } else {
        await this.doSubmit(id, selectedRecon);
      }
    },
    async doSubmit(id, selectedRecon) {
      // 未提交状态，允许变更内容
      if (id) {
        await taskApi.create({
          id,
          ...this.form.doctorInfo[2],
          reconIds: selectedRecon,
          examPatientId: this.form.examPatientId,
          examReportFile: this.form.examReportFile,
          note: this.form.note,
          patientName: this.form.patientName,
          patientPhone: this.form.patientPhone,
          rawFile: this.form.rawFile
        });
      }

      if (this.pageType === 'create') {
        const data = await taskApi.create({
          ...this.form.doctorInfo[2],
          reconIds: selectedRecon,
          examPatientId: this.form.examPatientId,
          examReportFile: this.form.examReportFile,
          note: this.form.note,
          patientName: this.form.patientName,
          patientPhone: this.form.patientPhone,
          rawFile: this.form.rawFile
        }) || {};
        if (data.code === 60009) {
          const msg = '代理商(' + data.data.agentName + ')预付金余额不足，无法提交新订单，请联系精诊科技销售经理';
          this.$confirm(msg, '余额不足', {
            confirmButtonText: '确定',
            type: 'error',
          }).then(async() => {
          });
        }
        if (data.code !== 10000) {
          return;
        }
        id = data.data;
      }
      const subData = await taskApi.submit(id) || {};
      if (subData.code === 10000) {
        tip.success('订单已提交！');
        this.resetForm();
        this.toOrderAll();
      }
    },
    async onRawDelected({path}) {
      const {id} = this.$route.params;
      this.form.rawFile = null;
      if (this.pageType !== 'create') {
        taskApi.removeCreateFile({id, rawFile: path});
      }
    },
    async onExamReportDelected({path}) {
      const {id} = this.$route.params;
      this.form.examReportFile = [];
      if (this.pageType !== 'create') {
        taskApi.removeCreateFile({id, examReport: [path]});
      }
    },
    /**
       * 加载 重建类型 数据
       */
    async loadReconData() {
      const recon = await taskApi.reconData() || {};
      if (recon.code === 10000) {
        this.reconData = recon.data;
      }
    },
    // 查询待上传数据的订单
    findTodoTask() {
      taskApi.fetchDraft({
        createBegin: Math.floor(new Date().getTime() / 1000) - 3600 * 24 * 7,
        createEnd: Math.floor(new Date().getTime() / 1000)
      }).then(res => {
        if (res.data && res.data.length > 0) {
          let orderTitles = res.data.map((item) => {
            return (item.patientName || '匿名') + '[' + (item.hospitalName || '') + ']';
          }).join('...');
          this.$confirm(orderTitles, '发现近期尚有' + res.count + '个订单待上传数据', {
            confirmButtonText: '查看',
            cancelButtonText: '取消',
            type: 'info',
          }).then(() => {
            this.$router.push({
              name: 'OrderUnsubmitInner'
            });
          });
        }
      });
    },
    // 根据医院名字搜索医院
    onHospitalQuerySearch(queryString, callback) {
      this.activeHospitalObj = null;
      if (queryString.length < 2) {
        // eslint-disable-next-line standard/no-callback-literal
        return callback([]);
      }
      taskApi.hospitalListName({
        pageSize: 100,
        pageNo: 1,
        name: queryString
      }).then(res => {
        if (res.code === 10000) {
          let hospitalList = res.data.data;
          hospitalList.forEach((hosp) => {
            hosp.value = hosp.name;
          });
          console.log(hospitalList);
          callback(hospitalList);
        }
      }).catch((e) => {
        // eslint-disable-next-line standard/no-callback-literal
        callback([]);
      });
    },
    onSelectHospital(activeHospitalObj) {
      this.activeHospitalObj = activeHospitalObj;
    },
    changeCheck(id, level) {
      this.reconData.forEach(item => {
        if (item.id === id && level === 1) {
          item.children.forEach(child => {
            if (child.def) child.check = item.check;
          });
        }
        if (item.id === id && level === 2) {
          // console.log(1);
          let allDefCount = 0;
          let checkDefCount = 0;
          item.children.forEach(child => {
            if (child.def) allDefCount += 1;
            if (child.def && child.check) checkDefCount += 1;
            item.check = allDefCount > 0 && allDefCount === checkDefCount;
          });
        }
      });
    },
  }
};
</script>
<style  lang="scss" scoped>
  .top-form-item {
    margin-top: 20px;
  }
  .mockData {
  /deep/ .el-table {
    border: 1px solid #9fa0a0;

  td {
    border: solid #9fa0a0;
    border-width: 0px 1px 1px 0px;
  }

  .el-table_1_column_2 .cell {
    padding-left: 0px;
    padding-right: 0px;

  .el-checkbox {
    margin: 10px;
    width: 200px;
  }

  .addition {
    float: left;
    margin: 10px;
    width: 200px;
  }
  }
  }

  .el-checkbox {
    margin: 10px;
    width: 200px;
  }
  }
</style>



// WEBPACK FOOTER //
// src/view/AdminOrderCreate/index.vue